import React, { createRef, PureComponent } from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import Moment from "moment";
import Input from "../theme/forms/Input";
import { updateDoorCrewCanvasser } from "../../store/api/calls/doors";
import { connect } from "react-redux";
import { AvailRoleToken } from "./DraggableShiftCanvasser";
import { get as _get } from "lodash";
import { getColorByModulo } from "../../utils/eventColors";
import { setSessionVar } from "../../store/actions";
import NoteTagList from "../theme/buttons/NoteTag";
import doorCrews from "../../store/reducers/doorCrews";

class SeatAssigment extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      editingIsDriver: false,
      editingIsDriverValue: false,
      editingRole: false,
      editingRoleValue: null,
      editingGoal: false,
      editingGoalValue: null,
      editingGoalPrevValue: null,
      editingComments: false,
      editingCommentsValue: null,
      editingCommentsPrevValue: null,
      editingAssignmentPlaceholder: null,
      assignmentPlaceholderValue: null,
    };

    // handle ref creation to autofocus on click for text fields
    // necessary because we use the onBlur() event to dispatch updates
    this.goalInputRef = createRef();
    this.commentsInputRef = createRef();
    this.roleSelectRef = createRef();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.seat.canvasser !== prevProps.seat.canvasser) {
        this.refresh();
    }
  }

  componentDidMount() {
    this.refresh()
  }

  refresh() {
    const roles = this.props.seat.roles || [];
    let role = false;
    let isDriver = false;

    if (this.state.editingRoleValue > 0) {
      // if both canvassers share the assigned role, preserve it
      let c_data = this.props.canvassers.find((d) => d.id === this.props.seat.canvasser) || {};
      c_data?.abilities.forEach(a => {
        if (a.id === this.state.editingRoleValue) {
          role = a
        }
      })
    } else if (this.state.editingIsDriverValue) {
      // if both canvassers share the assigned role, preserve it
      let c_data = this.props.canvassers.find((d) => d.id === this.props.seat.canvasser) || {};
      c_data?.abilities.forEach(a => {
        if (this.state.editingIsDriverValue === true && a.id === 1) {
          isDriver = true
        }
      })
    } else {
      role = roles.find((d) => d.name !== "Driver");
      isDriver = roles.find((d) => d.name === 'Driver');
    }
    console.log(`SEAT isDriver: ${isDriver}`, this.props.seat, this.props)

    this.setState({
      editingGoalValue: this.props.seat.goal,
      editingCommentsValue: this.props.seat.comments,
      editingRoleValue: role ? role.id : null,
      editingIsDriverValue: isDriver,
      assignmentPlaceholderValue: this.props.seat.assignment_placeholder_note,
    });
  }

  _deleteSeat = () => {
    if (this.props.data.seats.length <= 1) {
      this.props.onDeleteCrew();
    } else {
      console.log("DELETING", this.props.seat, this.props.data.seats);
      this.props.onDeleteSeat(
        this.props.seat.id,
        this.props.seat.turf?.id,
        this.props.seat.canvasser
      );
    }
  };

  _unnassignSeat = () => {
    this.props.onUnassignSeat(this.props.seat.id);
  };

  _updateCrewCanvasser = (seat_changes) => {
    return updateDoorCrewCanvasser(this.props.seat.id, seat_changes).then(
      (data) => {
        // the full and updated crew is returned.
        this.props.onCanvasserUpdate();
      }
    );
  };

  generateCanvasserDataLine = (canvasser_id) => {
    let c_data = this.props.canvassers.find((d) => d.id == canvasser_id);
    if (!c_data) {
      return (
        <div
          className={`canvasser-line`}
          style={{ marginBottom: this.props.displaySites ? "1em" : "0" }}
        >
          <div className={"line-item extra-long"}>
            <span className={"minor-title"}>Name</span>
            <span
              className={"edit-toggle no-click"}
              style={{ fontStyle: "italic", opacity: 0.7 }}
            >
              This canvasser has been deactivated
            </span>
          </div>
        </div>
      );
    }

    const _updateCrewCanvasserRole = (val) => {
      if (+val && val !== this.state.editingRoleValue) {
        let roles = [{ id: val }];
        if (this.state.editingRoleValue) {
          roles.push({ id: this.state.editingRoleValue, delete: true });
        }
        this._updateCrewCanvasser({ roles });
        //filter out everything but the driver role
        if (!this.props.seat.roles) {
          roles = []
        } else {
          roles = _get(this.props, "seat.roles", []).filter((d) => d.id === 1); //filter out everything but the driver
        }
      }

      this.setState({ editingRoleValue: +val }, () =>
        this.setState({ editingRole: false })
      );
    };

    //update state of editable components

    return (
      <div
        className={`canvasser-line`}
        style={{ marginBottom: this.props.displaySites ? "1em" : "0" }}
      >
        <div className={"line-item extra-long"}>
          <span className={"minor-title"}>Name</span>
          <span className={"edit-toggle no-click"}>
            {c_data.firstname} {c_data.lastname}
            <span className={"slashline"}>{c_data.metrics}</span>
          </span>
          {this.props.driver ? "SUGGESTED DRIVER SEAT " : null}
        </div>
        {/*field if they can be a driver*/}

        <div className={"line-item"}>
          <span className={"minor-title"}>Driver</span>
          {(c_data?.abilities || []).map((d) => d.name).includes("Driver") ? (
            <span
              className={"edit-toggle"}
              onDoubleClick={() => {
                this.setState({
                  editingIsDriverValue: !this.state.editingIsDriverValue,
                });
                this._updateCrewCanvasser({
                  roles: [
                    { id: 1, delete: this.state.editingIsDriverValue ? 1 : 0 },
                  ],
                });
              }}
            >
              {this.state.editingIsDriverValue ? (
                <span style={{ fontWeight: "bold" }}>Yes</span>
              ) : (
                <span
                  style={{
                    opacity: 0.7,
                    fontStyle: "italic",
                    fontSize: ".8em",
                  }}
                >
                  No
                </span>
              )}
            </span>
          ) : (
            <span
              className={"edit-toggle no-click"}
              style={{ opacity: 0.7, fontStyle: "italic", fontSize: ".8em" }}
            >
              n/a
            </span>
          )}
        </div>

        <div className={"line-item long"}>
          <span className={"minor-title"}>Role</span>
          {!this.state.editingRole && (
            <span
              className={"edit-toggle"}
              onDoubleClick={() => this.setState({ editingRole: true })}
            >
              {this.state.editingRoleValue ? (
                (
                  (c_data?.abilities || []).find(
                    (d) => d.id === +this.state.editingRoleValue
                  ) || {
                    name: " ",
                  }
                ).name
              ) : (
                <span
                  style={{
                    opacity: 0.7,
                    fontStyle: "italic",
                    fontSize: ".8em",
                  }}
                >
                  None
                </span>
              )}
            </span>
          )}
          {this.state.editingRole && (
            <Input
              type={"select"}
              options={[
                {
                  display: "- -",
                  value: 0,
                },
                ...(c_data?.abilities || [])
                  .filter((d) => d.name !== "Driver")
                  .map((d) => ({
                    display: d.name,
                    value: d.id,
                  })),
              ]}
              onChange={_updateCrewCanvasserRole}
              // onFocus={() => {
              //   //if you don't have one set, make role the first by default
              //   if (!this.state.editingRoleValue && (c_data?.abilities || []).length) {
              //     _updateCrewCanvasserRole(
              //       _get(
              //         (c_data?.abilities || []).filter((d) => d.id !== 1),
              //         '[0].id'
              //       )
              //     ); // dont' assign driver
              //   }
              // }}
              onBlur={() => this.setState({ editingRole: false })}
              value={this.state.editingRoleValue}
            />
          )}
        </div>

        {/*<div className={'line-item'}>*/}
        {/*    <span className={'minor-title'}>Role</span>*/}
        {/*    {!this.state.editingRole &&*/}
        {/*    <span*/}
        {/*        className={'edit-toggle'}*/}
        {/*        onDoubleClick={() => this.setState({editingRole: true})}>*/}
        {/*                {this.state.editingRoleValue ?*/}
        {/*                    (c_data.abilities.find(d => d.id === +this.state.editingRoleValue) || {name: " "}).name :*/}
        {/*                    <span style={{opacity: .7, fontStyle: 'italic', fontSize: '.8em'}}>None</span>}*/}
        {/*            </span>*/}
        {/*    }*/}
        {/*    {this.state.editingRole &&*/}
        {/*    <Input*/}
        {/*        type={'select'}*/}
        {/*        options={[ ...c_data.abilities.filter(d => d.name !== 'Driver').map(d => ({*/}
        {/*            display: d.name,*/}
        {/*            value: d.id,*/}
        {/*            selected: c_data.abilities.length === 1,*/}
        {/*        }))]}*/}
        {/*        onChange={(val) => {*/}
        {/*            let roles = val ? [{id: val}] : [];*/}
        {/*            if (this.state.editingRoleValue) {*/}
        {/*                roles.push({id: this.state.editingRoleValue, delete: true})*/}
        {/*            }*/}
        {/*            this._updateCrewCanvasser({roles});*/}
        {/*            //filter out everything but the driver role*/}
        {/*            roles = _get(this.props, 'seat.roles', []).filter(d => d.id === 1) //filter out everything but the driver*/}
        {/*            // add the selected one back in*/}
        {/*            this.setState({editingRoleValue: val}, () => this.setState({editingRole: false}))*/}
        {/*        }}*/}
        {/*        // onBlur={() => this.setState({editingRole: false})}*/}
        {/*        value={this.state.editingRoleValue}*/}
        {/*    />*/}
        {/*    }*/}
        {/*</div>*/}

        <div className={"line-item long"}>
          <span className={"minor-title"}>Comments</span>
          {!this.state.editingComments && (
            <span
              className={"edit-toggle"}
              onDoubleClick={() =>
                this.setState({ editingComments: true }, () => {
                  this.commentsInputRef.current.focus();
                })
              }
            >
              {this.state.editingCommentsValue || (
                <span
                  style={{
                    opacity: 0.7,
                    fontStyle: "italic",
                    fontSize: ".8em",
                  }}
                >
                  None
                </span>
              )}
            </span>
          )}
          {this.state.editingComments && (
            <input
              className={"edit-toggle"}
              type="text"
              value={this.state.editingCommentsValue}
              onChange={(ev) => {
                let val = ev.target.value;
                this.setState({ editingCommentsValue: val });
              }}
              onBlur={() => {
                this.setState({ editingComments: false });
                this._updateCrewCanvasser({
                  comments: this.state.editingCommentsValue,
                });
              }}
              ref={this.commentsInputRef}
            />
          )}
        </div>
        <div className={"line-item"}>
          <span className={"minor-title"}>Unassign / Delete</span>
          <span className={"flx"}>
            <span
              className={"edit-toggle no-after"}
              style={{ marginLeft: ".2em" }}
              onClick={this._unnassignSeat}
            >
              <i style={{ fontSize: ".8em" }} className={"fas fa-user-slash"} />
            </span>
            <span
              className={"edit-toggle no-after"}
              style={{ marginLeft: "1.5em" }}
              onClick={this._deleteSeat}
            >
              <i style={{ fontSize: ".8em" }} className={"fas fa-trash"} />
            </span>
          </span>
        </div>
      </div>
    );
  };

  generateUnnassignedDataLine = () => {
    return (
      <>
        <div className={`canvasser-line`}>
          <div className={"unnasigned-tag flx"}>
            <span style={{ fontStyle: "italic" }}>--- unnassigned ---</span>
            <span
              className={"edit-toggle no-after"}
              style={{ marginLeft: "2em" }}
              onClick={this._deleteSeat}
            >
              <i
                style={{ fontSize: ".8em", marginRight: ".5em" }}
                className={"fas fa-trash"}
              />{" "}
              Delete Seat
            </span>
          </div>
        </div>
        <div className={`canvasser-line`}>
          {!this.state.editingAssignmentPlaceholder && (
            <div
              className={"unnasigned-tag line-item clickable"}
              onDoubleClick={() =>
                this.setState({ editingAssignmentPlaceholder: true }, () => {
                  this.commentsInputRef.current.focus();
                })
              }
            >
              {this.state.assignmentPlaceholderValue &&
              this.state.assignmentPlaceholderValue.length ? (
                <span className={"primary-text"}>
                  {this.state.assignmentPlaceholderValue}
                </span>
              ) : (
                <span
                  style={{
                    opacity: 0.7,
                    fontStyle: "italic",
                    fontSize: ".8em",
                  }}
                >
                  Add a note about how to assign this seat.
                </span>
              )}
            </div>
          )}
          {this.state.editingAssignmentPlaceholder && (
            <>
              <h6>Assignment Note</h6>
              <input
                className={"edit-toggle"}
                type="text"
                value={this.state.assignmentPlaceholderValue}
                onChange={(ev) => {
                  let val = ev.target.value;
                  this.setState({
                    assignmentPlaceholderValue: val.length ? val : null,
                  });
                }}
                onBlur={() => {
                  this.setState({ editingAssignmentPlaceholder: false });
                  this._updateCrewCanvasser({
                    assignment_placeholder_note:
                      this.state.assignmentPlaceholderValue,
                  });
                }}
                ref={this.commentsInputRef}
              />
            </>
          )}
        </div>
      </>
    );
  };

  render() {
    let turf = this.props.seat.turf || {};
    let turfcode =
      this.props.turfCodes.find((d) => d.id === this.props.seat?.turf?.code) ||
      {};

    return (
      <div
        className={`crew-seat`}
        key={"turf-" + this.props.seat.id}
        style={{ borderColor: this.props.color }}
      >
        <Droppable droppableId={"turf-assign_seat_" + this.props.seat.id}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              className={snapshot.isDraggingOver ? "primary light" : ""}
            >
              <div className={"inputWrapper"}>
                {!!this.props.seat.canvasser &&
                  !this.state.editing &&
                  this.generateCanvasserDataLine(this.props.seat.canvasser)}
                {!this.props.seat.canvasser &&
                  this.generateUnnassignedDataLine()}
              </div>

              <div className={"turf-label"}>
                <div className={"turf-name"}>{turf.name}</div>
                <div className={"turf-agg-data"}>
                  {turf.household_count} Doors
                </div>
                {turf.agg_data && (
                  <div className={"turf-agg-data primary-text"}>
                    {turf.agg_data.households_attempted} doors /{" "}
                    {turf.agg_data.targets_attempted} targets attempted.
                  </div>
                )}
                {!!turfcode.name && (
                  <div
                    className={"turf-agg-data"}
                    style={{ color: turfcode.walkable ? "inherit" : "#C83931" }}
                  >
                    {turfcode.name}
                  </div>
                )}
                {!!this.props.seat.dropoff_lat &&
                  !!this.props.seat.dropoff_lon && (
                    <div
                      className={"turf-agg-data success-text"}
                      style={{ fontSize: "11px", marginTop: ".4em" }}
                    >
                      <i className={"fa fa-check-circle"} /> Dropoff Assigned
                    </div>
                  )}
              </div>
              <div className={"turf-label"}>
                <div
                  className={"notes-in-table"}
                  onClick={() =>
                    this.props.setTurfNoteModalTurf({
                      ...turf,
                      crew_id: this.props.crew_id,
                    })
                  }
                >
                  <NoteTagList addButton notes={turf.turfnotes} />
                </div>
              </div>

              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    );
  }
}

class DraggableCrewTurfAssignment extends PureComponent {
  constructor(props) {
    super(props);
  }

  _renderSitesData(sites) {
    let sitesCount = 0;
    // TODO: render appropriate site metadata based on column or droppable context here.
    if (this.props.availableRoute) {
      // just render number of sites for now
      return this.sites.length;
    }
  }

  _getCanvasserOptions = () => {
    let options = (this.props.canvassers || []).map((d) => {
      return {
        display: d.firstname + " " + d.lastname,
        value: d.id,
      };
    });

    options.unshift({ display: "", value: 0 });
    return options;
  };

  _renderRouteSeats(crew_id) {
    if (!this.props.data.seats) return null;

    let seats = this.props.data.seats.map((item, index) => {
      return (
        <SeatAssigment
          {...this.props}
          seat={item}
          key={item.id + index}
          first={index === 0}
          crew_id={this.props.data.id}
        />
      );
    });

    //drop mat to create a new seat
    seats.push(
      <Droppable droppableId={"create-seat_" + this.props.data.id}>
        {(provided, snapshot) => (
          <div ref={provided.innerRef}>
            {/* I know the classname assignment here is crazy, but it's the only way to get the right behaviour before drop*/}
            <div
              id={"add-seat-drop-mat-" + this.props.data.id}
              className={`add-seat-drop-mat  
                                ${
                                  document.getElementById(
                                    "add-seat-drop-mat-" + this.props.data.id
                                  ) &&
                                  document
                                    .getElementById(
                                      "add-seat-drop-mat-" + this.props.data.id
                                    )
                                    .className.includes("active")
                                    ? "active"
                                    : ""
                                }  
                                ${
                                  snapshot.isDraggingOver
                                    ? "active primary light"
                                    : ""
                                }`}
            >
              <div className="drop-text">+ Create a new seat</div>
            </div>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    );

    return seats;
  }

  //a hack for prepping the dropmap in drag, because changing state/props causes a rerender with many problems
  handleBeforeDrag = () => {
    this.props.beforeDrag();
  };

  _renderAvailableTurf(provided, snapshot) {
    let { agg_data } = this.props.data;
    let pass_data =
      this.props.doorCanvassPasses.find(
        (d) => d.id === this.props.data.doorcanvasspass
      ) || {};

    let turfcode =
      this.props.turfCodes.find((d) => d.id === this.props.data?.code) || {};
    return (
      <div
        className={`schedule-sr-card`}
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...{
          ...provided.dragHandleProps,
          onMouseDown: (...args) => {
            this.handleBeforeDrag();
          },
          onMouseUp: () => {
            this.props.handleMouseUp();
          },
          onContextMenu: () => {
            this.props.handleMouseUp();
          },
        }}
      >
        <div
          className="available-route"
          style={{ borderLeftColor: this.props.color, color: this.props.color }}
          id={this.props.id}
        >
          <div className="obj-title">{this.props.name}</div>
          <div className="obj-data">
            {this.props.data.household_count} doors
          </div>
          {!!turfcode?.name && (
            <div className="obj-data">
              <span
                style={{ color: turfcode.walkable ? "inherit" : "#C83931" }}
              >
                {turfcode.name}
              </span>
            </div>
          )}
          {!!pass_data.name && (
            <div className="obj-data">
              <span style={{ color: getColorByModulo(pass_data.id) }}>
                {pass_data.name}
              </span>
            </div>
          )}
          {this.props.data.household_count_before_suppression &&
            this.props.data.household_count_before_suppression >
              this.props.data.household_count && (
              <div className="obj-data danger-text">
                <span>
                  <i
                    className="fas fa-exclamation-triangle"
                    style={{ padding: "0em .5em" }}
                  />
                  <b>
                    {this.props.data.household_count_before_suppression -
                      this.props.data.household_count}
                  </b>{" "}
                  Doors Suppressed
                </span>
              </div>
            )}
          {agg_data ? (
            <div className="obj-data primary-text">
              {agg_data.households_attempted} doors /{" "}
              {agg_data.targets_attempted} targets attempted.
            </div>
          ) : null}
          {!!this.props.data.assigned && (
            <div className="obj-data small-font">
              <span className={"assignedToken"}>Assigned</span>
            </div>
          )}
          <div
            className={"notes-in-table"}
            onClick={() =>
              this.props.setTurfNoteModalTurf({
                ...this.props.data,
                crew_id: this.props.crew_id,
              })
            }
          >
            <NoteTagList addButton notes={this.props.data.turfnotes} />
          </div>
        </div>
      </div>
    );
  }

  _generateIncludedRoles() {
    let roles = this.props.routeseats.reduce((agg, d, i, a) => {
      return agg.concat(d.roles);
    }, []);

    roles = roles
      .sort((a, b) => a.id - b.id)
      .filter((d) => d?.id)
      .map((role) => {
        return <AvailRoleToken role={(role || {}).name} />;
      });

    return <span className="crew-role-tokens">{roles}</span>;
  }

  _getShiftLabel = () => {
    const shift = (this.props.shiftData || []).find(
      (d) => d.id == this.props.data.shift
    );
    if (!shift) return "No Shift";
    return (
      new Moment(`${shift.shift_date} ${shift.start_time}`).format("LT") +
      " - " +
      new Moment(`${shift.shift_date} ${shift.end_time}`).format("LT")
    );
  };

  _renderCrewCard(provided, snapshot) {
    const shiftLabel = this._getShiftLabel();
    let innerCard = (
      <>
        <div className={"crew-card-top-icons"}>
          <i
            className="remove-crew-icon far fa-times-circle"
            onClick={this.props.onDeleteCrew}
          ></i>
        </div>
        <div
          className={"crew-title"}
          style={{ color: this.props.data.color || "red" }}
        >
          Crew {this.props.data.id}
          {shiftLabel ? ` · ${shiftLabel}` : null}
          {/* {this._generateIncludedRoles()} */}
        </div>
        <div className={"seat-wrapper"}>{this._renderRouteSeats()}</div>
        <div className={"crew-card-bottom-buttons"}>
          <div
            className={"button button-clear"}
            onClick={this.props.handleAssignDropoffRequest}
          >
            Assign Dropoff Locations
          </div>
        </div>
      </>
    );

    if (provided && snapshot) {
      return (
        <div
          className={`assign-crew-card`}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {innerCard}
        </div>
      );
    } else {
      return <div className={`assign-crew-card`}>{innerCard}</div>;
    }
  }

  // TODO: add classNames conditionally based off of which scheduling column the siteroute is in
  // TODO: need different class for the remove icon
  render() {
    let { draggableId, draggable, cardInDraggableContext } = this.props;
    return cardInDraggableContext !== false ? (
      <Draggable
        draggableId={draggableId}
        index={this.props.index}
        key={this.props.draggableId + this.props.index}
        type={this.props.dragType || "DEFAULT"}
      >
        {(provided, snapshot) => (
          <>
            {/*TODO: THIS SHOULD BE THE EDITABLE CANVASSER ASSIGNMENT*/}
            {this.props.availableTurf &&
              this._renderCrewCard(provided, snapshot)}
            {/*THIS IS THE SIDEBAR VIEW*/}
            {!this.props.availableTurf &&
              this._renderAvailableTurf(provided, snapshot)}
          </>
        )}
      </Draggable>
    ) : (
      this._renderCrewCard()
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setTurfNoteModalTurf: (turf) =>
    dispatch(setSessionVar("turfNoteModalTurf", turf)),
});

const mapStateToProps = (state) => ({
  canvassers: state.canvassers.data,
  crews: state.crews.data,
  doorCanvassPasses: state.doorCanvassPasses.data,
  turfCodes: state.turfCodes.data,
  doorCrews: state.doorCrews
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DraggableCrewTurfAssignment);
